import { useEffect, useRef, useState } from "react";
import { fileUrl } from "@/lib/api";

// Tiny blurred preview shown until the full image has loaded.
export const BlurImage = ({ path, w = 1280, alt = "", fill = false, className = "", wrapperClassName = "", eager = false, testid }) => {
  const [loaded, setLoaded] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    setLoaded(false);
    if (ref.current?.complete && ref.current.naturalWidth) setLoaded(true);
  }, [path]);

  const full = (
    <img
      ref={ref}
      src={fileUrl(path, w)}
      alt={alt}
      data-testid={testid}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      onLoad={() => setLoaded(true)}
      className={`${fill || !loaded ? "absolute inset-0 w-full h-full" : "relative block w-full h-auto"} transition-[opacity,transform] duration-500 ${loaded ? "opacity-100" : "opacity-0"} ${className}`}
    />
  );

  return (
    <span className={`block relative overflow-hidden bg-slate-900 ${fill ? "w-full h-full" : ""} ${wrapperClassName}`}>
      {(fill || !loaded) && (
        <img
          src={fileUrl(path, 32)}
          alt=""
          aria-hidden="true"
          data-testid={testid ? `${testid}-placeholder` : undefined}
          className={`${fill ? "absolute inset-0 h-full" : "block h-auto"} w-full object-cover blur-xl scale-110 transition-opacity duration-500 ${loaded ? "opacity-0" : "opacity-100"}`}
        />
      )}
      {full}
    </span>
  );
};
